/**
 * Card click handler using event delegation.
 * Treats the entire card as a link to its primary heading anchor
 * while preserving default browser behavior for other links within the card.
 */
export default function card() {
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.card');
    if (!card) return;

    const cardLink = card.querySelector('a:has(> h2)');
    if (!cardLink) return;

    const clickedLink = e.target.closest('a');
    if (clickedLink && clickedLink !== cardLink) return;

    if (e.target.tagName !== 'A' && cardLink instanceof HTMLElement) {
      e.preventDefault();
      cardLink.click();
    }
  });
}
